import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@material-ui/core";
import { languages } from "../../constants/languages";

const PinnedMessageDialog = ({
  open,
  toggleDialog,
  title,
  message,
  handleTitleChange,
  handleMessageChange,
  handleSubmit,
}) => {
  return (
    <Dialog open={open} onClose={toggleDialog}>
      <form onSubmit={handleSubmit}>
        <DialogTitle>{languages.tournament.pinnedMessageNew}</DialogTitle>
        <DialogContent style={{ width: 400, maxWidth: "97%", paddingTop: 0 }}>
          <TextField
            autoFocus
            margin="dense"
            label={languages.tournament.pinnedMessageTitle}
            fullWidth
            value={title}
            onChange={handleTitleChange}
            inputProps={{ maxLength: 50 }}
            helperText={
              title.length +
              "/50 " +
              languages.tournament.pinnedMessageCharacters
            }
          />
          <TextField
            margin="dense"
            label={languages.tournament.pinnedMessageContent}
            fullWidth
            multiline
            value={message}
            onChange={handleMessageChange}
            inputProps={{ maxLength: 150 }}
            helperText={
              message.length +
              "/150 " +
              languages.tournament.pinnedMessageCharacters
            }
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={toggleDialog} color="primary">
            {languages.general.cancel}
          </Button>
          <Button
            disabled={title.length === 0 || message.length === 0}
            variant="contained"
            color="primary"
            type="submit"
          >
            {languages.general.save}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default PinnedMessageDialog;
